import { render, staticRenderFns } from "./SeleccionPolizas.vue?vue&type=template&id=2e88e582&scoped=true&"
import script from "./SeleccionPolizas.vue?vue&type=script&lang=js&"
export * from "./SeleccionPolizas.vue?vue&type=script&lang=js&"
import style0 from "./SeleccionPolizas.vue?vue&type=style&index=0&id=2e88e582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e88e582",
  null
  
)

export default component.exports